<template>
  <div style="width:257px" :attrs="$attrs">
    <a-select v-model="selectedValue" showSearch :mode="multiple ? 'multiple' : 'default'" style="width: 98%"
      optionFilterProp="children" :maxTagTextLength="17" :maxTagCount="maxTagCount" :placeholder="$t('allBranches')"
      :options="branchOption" :filterOption="(input, option) =>
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
        " @change="changeValue" />
  </div>
</template>

<script>
export default {
  name: 'branchFilter',
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    maxTagCount: {
      type: Number,
      default: () => 1
    },
    currentCompany: {
      type: Boolean,
      default: () => false
    },
    value: {
      type: [Array, Number, String],
      default: () => []
    }
  },
  data() {
    return {
      selectedValue: this.value,
      options: []
    }
  },
  created() {
    this.fetchBranch()
  },
  computed: {
    defaultBranchId() {
      var authUser = this.$store.state.authUser
      return (authUser && authUser.default_branch_id) ? authUser.default_branch_id : null
    },

    branchOption() {
      var options = Array.isArray(this.options) ? this.options : []

      function toOption(el) {
        return {
          value: el.branch_id,
          id: el.branch_id,
          label: el.branch_name_en
        }
      }

      if (!options.length) {
        return []
      }

      try {
        if (this.defaultBranchId && this.currentCompany) {
          var defaultBranch = options.find(function (o) {
            return o.branch_id == this.defaultBranchId
          }, this)

          if (defaultBranch && defaultBranch.company_id != null) {
            var filtered = options.filter(function (o) {
              return o.company_id == defaultBranch.company_id
            })

            return filtered.length ? filtered.map(toOption) : options.map(toOption)
          }
        }

        return options.map(toOption)
      } catch (error) {
        console.error('Failed to build branchOption list:', error)
        return options.map(toOption)
      }
    }
  },
  methods: {
    fetchBranch() {
      this.$store
        .dispatch('branch/fetch', {
          page: -1,
          fields: {
            setup_branch_profiles: 'branch_id,branch_name_en,company_id'
          },
          filter: {
            user_branches: 1
          }
        })
        .then(response => {
          this.options = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    changeValue(value) {
      this.$emit('input', value)
      this.$emit('filter', value)
    }
  },
  watch: {
    value(value) {
      this.selectedValue = value
    }
  }
}
</script>
<style lang="css" scoped>
.vue-treeselect__control {
  height: 34px !important;
}
</style>
